import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../App.scss';
import getQuizAnalytics, { QuizAnalytics } from '../helpers/getQuizAnalytics';

const formatSeconds = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs}s`;
};

const QuizAnalyticsComponent: React.FC = () => {
  const [analytics, setAnalytics] = useState<QuizAnalytics | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const date = "20251128"; // Isti datum kao u getWinnersWeekly
        const data = await getQuizAnalytics(date);
        
        if (data) {
          setAnalytics(data);
        } else {
          setError("Nema dostupnih podataka.");
        }
      } catch (err) {
        console.error("Error fetching analytics:", err);
        setError("Greška pri učitavanju podataka.");
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, []);

  if (loading) {
    return (
      <section id="analitika" className="quiz-analytics-section">
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <div className="analytics-loading">
                <p>Učitavanje statistike...</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }

  if (error || !analytics) {
    return (
      <section id="analitika" className="quiz-analytics-section">
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <div className="analytics-error">
                <p>{error || "Nema dostupnih podataka."}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }

  return (
    <section id="analitika" className="quiz-analytics-section">
      <Container>
        <Row className="justify-content-center">
          <Col md={10}>
            <div className="analytics-wrapper">
              <h2 className="analytics-title">STATISTIKA KVIZA</h2>
              <div className="analytics-grid">
                <div className="analytics-item">
                  <span className="analytics-label">UKUPNO TAKMIČARA</span>
                  <span className="analytics-value">{analytics.ukupno_takmicara}</span>
                </div>
                <div className="analytics-item">
                  <span className="analytics-label">PROSEČAN REZULTAT</span>
                  <span className="analytics-value">{Number(analytics.prosecan_rezultat).toFixed(1)} poena</span>
                </div>
                <div className="analytics-item">
                  <span className="analytics-label">NAJBOLJI REZULTAT</span>
                  <span className="analytics-value">{Number(analytics.najbolji_rezultat)} poena</span>
                </div>
                <div className="analytics-item">
                  <span className="analytics-label">NAJBRŽI KVIZ</span>
                  <span className="analytics-value">{formatSeconds(Number(analytics.najbrzi_kviz_sekunde))}</span>
                </div>
                <div className="analytics-item analytics-item-full">
                  <span className="analytics-label">PROSEČNO VREME</span>
                  <span className="analytics-value">{formatSeconds(Number(analytics.prosecno_vreme_sekunde))}</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default QuizAnalyticsComponent;

